module.exports = __webpack_public_path__ + "static/media/bicycles_featured.bde1638b.jpg";